<p-messages></p-messages>
<div class="video-container">
    <video #videoPlayer controls class="video-player" [poster]="getPosterUrl()" playsinline>
    </video>
</div>